import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';

export const StyledImage = styled('img', {
  shouldForwardProp: (props) => props !== 'isActive',
})<{ isActive?: boolean }>(({ theme, isActive = false }) => ({
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
  outlineOffset: theme.spacing(0.5),
  outlineWidth: theme.spacing(0.5),
  outlineColor: theme.palette['Colors/Effects/Focus rings/focus-ring'],
  ...(isActive && {
    outlineStyle: 'solid',
  }),
}));

export const StyledStack = styled(Stack)(() => ({
  flex: 1,
  height: '100%',
}));

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  flex: 1,
}));

export const StyledCenteredStack = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: theme.spacing(99.25),
  },
}));
